var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.73,186.5a142.17,142.17,0,0,0-10.32-24.88c-21.76-40.44-59.92-70.95-101.66-89-33.14-14.31-74.12-21.79-109.28-8.9-17.78,6.52-34.52,19-44.05,35.65C153,121.11,154.17,148,144.31,170.85c-8,18.49-27.88,29.6-43.46,41-24.31,17.72-48.26,38.67-56.69,68.64C32.92,320.44,36.25,368,59,403.53c17,26.51,46.1,34.47,76.13,35,28.34.51,63-6.65,89.45,6.28,45.06,22,104.52,46.7,154.94,29.29,52-17.95,77.47-52.91,85-98.26s-13.22-83.13-19.84-119C440.56,234.15,437.83,209.1,430.73,186.5Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.73,186.5a142.17,142.17,0,0,0-10.32-24.88c-21.76-40.44-59.92-70.95-101.66-89-33.14-14.31-74.12-21.79-109.28-8.9-17.78,6.52-34.52,19-44.05,35.65C153,121.11,154.17,148,144.31,170.85c-8,18.49-27.88,29.6-43.46,41-24.31,17.72-48.26,38.67-56.69,68.64C32.92,320.44,36.25,368,59,403.53c17,26.51,46.1,34.47,76.13,35,28.34.51,63-6.65,89.45,6.28,45.06,22,104.52,46.7,154.94,29.29,52-17.95,77.47-52.91,85-98.26s-13.22-83.13-19.84-119C440.56,234.15,437.83,209.1,430.73,186.5Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.61,322.66c-.26-2.89-.32-5.55-.35-7.91,0-1.34,0-2.55,0-3.68,1-.85,5.17-4.3,6.32-6.63s1.93-5.5.71-7.94a4.58,4.58,0,0,0-6.45-2.09c-3.23,2-3.5,8.91-2.63,12.24.07.29,1.76,4.65,1.81,4.61l.07-.05c-.05,1.09-.1,2.26-.12,3.53,0,2.36,0,5,.18,7.94,0,.48.07,1,.11,1.49.36.54.56.89.56.89C51.78,324.25,51.68,323.43,51.61,322.66Z",
    style: {
      fill: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.22,315.33c-4.34.71-4.9,4.78-.85,7.38,3.43,2.2,9.29,2.35,11,2.35,0-.3,0-.6-.07-.89C49.66,321.66,44.78,314.74,41.22,315.33Z",
    style: {
      fill: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.57,296.23c-3.83-.12-7.87,5.42-9,8.64-.1.28-1.08,4.82-1,4.81h.08c-.65.87-1.33,1.81-2,2.86-1.32,1.94-2.79,4.14-4.22,6.64l-.5.87c-.07.7-.13,1.12-.13,1.12l-.34-.28a72.69,72.69,0,0,0-3.29,6.61,58.43,58.43,0,0,0-3.38,9.9s0,.08,0,.12c-.08-1.12-.42-4.25-.47-4.48-.75-3.36-4.15-9.43-8-9.84a4.46,4.46,0,0,0-4.83,4.64c0,2.71,2.22,5.26,4.27,6.81,2.32,1.76,8.43,3.17,8.91,3.28a81,81,0,0,0-1.56,10.57c-.18,2.07-.29,4.16-.38,6.27-.11-1-.2-1.84-.23-2-.75-3.35-4.15-9.42-8-9.83a4.45,4.45,0,0,0-4.82,4.64c0,2.71,2.22,5.25,4.27,6.81s7.27,2.89,8.65,3.21c0,.81-.06,1.61-.08,2.42-.11,3.87-.21,7.73-.41,11.52-.07,1.33-.19,2.64-.31,3.95-.09-.86-.17-1.58-.2-1.69-.74-3.35-4.15-9.42-8-9.83a4.44,4.44,0,0,0-4.82,4.64c0,2.71,2.21,5.25,4.26,6.81s6.77,2.75,8.4,3.15c-.11.92-.22,1.84-.35,2.74.58.17,1.17.31,1.78.43.22-1.74.39-3.51.53-5.3,1.42.4,6.5,1.75,9,1.38s5.62-1.54,6.89-3.92a4.59,4.59,0,0,0-2.11-6.44c-3.56-1.5-9.34,2.19-11.54,4.78-.13.16-1.5,2.2-2.23,3.33.09-1.31.18-2.61.22-3.93.13-3.83.14-7.71.16-11.57,0-1.19,0-2.37,0-3.55.51.15,6.51,1.88,9.35,1.46,2.53-.37,5.62-1.54,6.89-3.91a4.58,4.58,0,0,0-2.12-6.44c-3.55-1.5-9.33,2.18-11.53,4.77-.16.2-2.12,3.13-2.58,3.9,0-2.6.1-5.19.26-7.74a80.33,80.33,0,0,1,1.28-10.26c.24.07,6.5,1.9,9.4,1.48,2.53-.37,5.63-1.55,6.89-3.92a4.59,4.59,0,0,0-2.11-6.44c-3.55-1.5-9.34,2.19-11.54,4.78-.17.2-2.27,3.36-2.62,4,0-.2.06-.41.1-.6a57.63,57.63,0,0,1,3.13-9.85c.71-1.77,1.49-3.41,2.29-5,1.13.46,6.33,2.51,9,2.42s5.77-.91,7.29-3.13a4.56,4.56,0,0,0-1.4-6.62c-3.37-1.88-9.54,1.14-12,3.47-.13.12-1.35,1.57-2.23,2.63.37-.71.74-1.45,1.11-2.12,1.38-2.53,2.8-4.76,4.07-6.72.73-1.11,1.42-2.1,2.07-3,1.33-.12,6.72-.69,9-2s4.65-3.47,5-6.15A4.62,4.62,0,0,0,127.57,296.23Z",
    style: {
      fill: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,378.79c.26.51.51,1,.76,1.54l1.71-.56c-.65-1.29-1.32-2.58-2-3.85,1.39-.45,6.33-2.12,8.21-3.83s3.79-4.41,3.53-7.1a4.63,4.63,0,0,0-5.3-4.27c-3.76.7-6.5,7-6.88,10.39,0,.22,0,2.69,0,4-.66-1.14-1.3-2.29-2-3.43-2-3.3-4.14-6.57-6.26-9.84l-1.92-3c.5-.15,6.41-2,8.52-3.93,1.88-1.7,3.79-4.4,3.53-7.09a4.62,4.62,0,0,0-5.3-4.27c-3.76.7-6.5,7-6.88,10.39,0,.26,0,3.81,0,4.72-1.41-2.22-2.79-4.44-4.06-6.68a82.44,82.44,0,0,1-4.6-9.35c.23-.07,6.41-2,8.57-3.95,1.88-1.7,3.79-4.4,3.53-7.1a4.62,4.62,0,0,0-5.3-4.26c-3.76.7-6.5,7-6.88,10.39,0,.27,0,4.09,0,4.79-.07-.19-.17-.38-.24-.56a59.66,59.66,0,0,1-2.86-10c-.39-1.88-.65-3.7-.87-5.48,1.19-.23,6.61-1.38,8.76-2.92s4.25-4,4.29-6.66a4.63,4.63,0,0,0-4.81-4.82c-3.82.28-7.24,6.23-8,9.56,0,.18-.26,2.07-.4,3.45h-.49c.19,2.22.46,4.56.9,7a59.15,59.15,0,0,0,2.67,10.22.37.37,0,0,0,.05.11c-.69-.9-2.69-3.35-2.86-3.52-2.47-2.41-8.62-5.65-12-3.89a4.5,4.5,0,0,0-1.42,6.57c1.52,2.27,4.73,3.21,7.28,3.38,2.88.21,8.7-2,9.16-2.15a80.9,80.9,0,0,0,4.54,9.77c1,1.85,2.05,3.68,3.14,5.5-.62-.76-1.18-1.44-1.27-1.52-2.46-2.42-8.62-5.66-12-3.9a4.5,4.5,0,0,0-1.42,6.58c1.51,2.27,4.73,3.2,7.28,3.38S63,361,64.33,360.5c.43.69.84,1.39,1.27,2.08,2,3.32,4.1,6.63,6,9.93.67,1.17,1.3,2.34,1.92,3.51-.55-.68-1-1.24-1.09-1.32-2.47-2.41-8.63-5.65-12-3.89A4.5,4.5,0,0,0,59,377.38c1.51,2.27,4.73,3.21,7.28,3.39S73.41,379.35,75,378.79Z",
    style: {
      fill: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.66,306.89c-3.81-2.19-6.82.62-5.32,5.19,1.28,3.91,5.81,7.78,7.09,8.8l.47-.84C111.22,317,111.77,308.67,108.66,306.89Z",
    style: {
      fill: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.31,465.56c-4.22.11-8.31,6.5-9.32,10.14-.05.19-.38,2.18-.6,3.69q3,.27,6,.42a15,15,0,0,0,3.9-1.54c2.35-1.53,4.9-4.14,5.08-7.13A5.09,5.09,0,0,0,339.31,465.56Z",
    style: {
      fill: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.89,409c-4.86,0-6.18,4.36-2.21,7.9,3.35,3,9.72,4.19,11.58,4.49l.09-1C311,417.34,306.88,408.94,302.89,409Z",
    style: {
      fill: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.15,464.84a5.07,5.07,0,0,0-1.18-7.4c-3.61-2.25-10.57.76-13.41,3.2-.22.18-2.86,3.05-3.5,3.81.49-2.84,1-5.65,1.64-8.41a87.17,87.17,0,0,1,3.18-11c.25.12,6.75,3.21,10,3.26,2.82,0,6.4-.71,8.19-3.07a5.07,5.07,0,0,0-1.18-7.4c-3.61-2.25-10.57.76-13.41,3.2-.23.19-3.07,3.27-3.55,3.87.08-.21.13-.43.21-.64a64,64,0,0,1,5.13-10.2c1.08-1.8,2.22-3.46,3.37-5,1.15.7,6.47,3.84,9.39,4.2s6.45,0,8.49-2.14a5.05,5.05,0,0,0-.37-7.47c-3.35-2.64-10.6-.41-13.7,1.69-.17.12-1.75,1.48-2.89,2.48.52-.71,1.06-1.45,1.57-2.12,1.95-2.52,3.88-4.7,5.61-6.62,1-1.08,1.91-2,2.78-2.93,1.48.1,7.46.42,10.15-.59s5.68-3,6.49-5.85a5.1,5.1,0,0,0-3.75-6.51c-4.15-.81-9.52,4.54-11.29,7.86-.15.29-2,5.06-1.94,5.07h.09c-.85.83-1.76,1.74-2.73,2.75-1.77,1.89-3.76,4-5.77,6.52l-.69.86c-.2.75-.33,1.19-.33,1.19s-.13-.13-.33-.36c-1.59,2-3.21,4.22-4.74,6.63a64.47,64.47,0,0,0-5.41,10.22s0,.09,0,.13c.11-1.24.29-4.71.27-5-.22-3.79-2.88-11-7-12.12a4.93,4.93,0,0,0-6.07,4.23c-.44,3,1.5,6.11,3.47,8.17,2.22,2.32,8.64,4.92,9.15,5.13a87.52,87.52,0,0,0-3.55,11.26c-.55,2.22-1,4.49-1.51,6.76.06-1.07.1-2,.09-2.16-.23-3.79-2.88-11-7-12.12a4.91,4.91,0,0,0-6.07,4.22c-.44,3,1.5,6.12,3.47,8.18s7.43,4.41,8.87,5l-.51,2.62c-.68,3.59-1.35,7.17-2.09,10.7l1.8-.25c.62-3.37,1.19-6.77,1.75-10.17.21-1.29.44-2.57.67-3.86.52.25,6.77,3.18,9.94,3.23C375.78,467.94,379.36,467.2,381.15,464.84Z",
    style: {
      fill: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.93,411.51c-3.78-3.05-7.54-.51-6.71,4.73.72,4.5,5,9.5,6.2,10.84l.66-.83C379,423,381,414,377.93,411.51Z",
    style: {
      fill: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,418.76c.22-3.19.62-6.11,1-8.68.22-1.46.45-2.78.68-4,1.28-.74,6.39-3.79,8.05-6.13s3.06-5.66,2.16-8.53a5.07,5.07,0,0,0-6.67-3.41c-3.88,1.63-5.37,9.11-5,12.89,0,.33,1.11,5.38,1.18,5.35l.08-.05c-.25,1.18-.5,2.45-.74,3.84-.44,2.57-.9,5.48-1.19,8.69-.05.53-.1,1.09-.14,1.64.29.66.46,1.07.46,1.07C312.85,420.54,312.89,419.62,313,418.76Z",
    style: {
      fill: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.2,472.83a4.67,4.67,0,0,0-3.15,3.89c5.17,1,10.34,1.83,15.5,2.38C324.25,476,318.16,471.51,314.2,472.83Z",
    style: {
      fill: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.52,471a4.91,4.91,0,0,0-6.07,4.22,7.92,7.92,0,0,0,1,4.73q5.67-.12,11.26-.75C355.6,475.68,353.43,471.81,350.52,471Z",
    style: {
      fill: "#bababa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.71,476c-1.61-3.94-3.37-7.89-5.1-11.83-.53-1.2-1.05-2.41-1.57-3.62.57-.08,7.34-1.07,10-2.8,2.35-1.53,4.9-4.14,5.08-7.13a5.09,5.09,0,0,0-5-5.57c-4.22.1-8.31,6.5-9.32,10.13-.08.28-.7,4.16-.8,5.15-1.15-2.66-2.27-5.32-3.26-8a89,89,0,0,1-3.39-11c.26,0,7.33-1,10-2.8,2.34-1.53,4.9-4.15,5.08-7.13a5.1,5.1,0,0,0-5-5.58c-4.22.11-8.31,6.5-9.32,10.14-.08.28-.74,4.46-.8,5.22-.05-.21-.13-.43-.18-.65a65.7,65.7,0,0,1-1.36-11.44c-.1-2.12-.07-4.15,0-6.12,1.33-.05,7.44-.36,10.06-1.67s5.33-3.57,5.83-6.51a5.1,5.1,0,0,0-4.4-6.09c-4.21-.37-9,5.53-10.39,9-.07.19-.63,2.22-1,3.7l-.55-.08c-.18,2.45-.29,5-.23,7.76a66,66,0,0,0,1.13,11.61l0,.13c-.59-1.1-2.35-4.12-2.51-4.34-2.27-3.06-8.42-7.67-12.41-6.34a5,5,0,0,0-2.69,6.93c1.25,2.73,4.6,4.32,7.35,5,3.1.72,9.83-.65,10.37-.76a90.67,90.67,0,0,0,3.24,11.45c.77,2.19,1.61,4.37,2.47,6.54-.54-.93-1-1.77-1.11-1.87-2.27-3.07-8.42-7.67-12.41-6.34a5,5,0,0,0-2.69,6.92c1.25,2.74,4.59,4.32,7.35,5s8.55-.4,10.07-.7c.34.83.67,1.66,1,2.49,1.65,4,3.32,7.95,4.83,11.89.32.84.62,1.68.92,2.51l2,.2C328.59,478.24,328.17,477.12,327.71,476Z",
    style: {
      fill: "#bababa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.14,161.62l.66,3.95,4.4.39,1.32-3.74a17.42,17.42,0,0,0,4.23-.92l2.78,2.82,3.82-2.21-1.05-3.8a17.47,17.47,0,0,0,2.93-3.2l3.88.72,1.87-4-3.05-2.51a17.41,17.41,0,0,0,.55-4.3l3.62-1.64-.77-4.35-4-.31a17.29,17.29,0,0,0-2-3.78l2.06-3.48-3.12-3.12-3.5,2.08a17.63,17.63,0,0,0-6.69-2.73l-1-4h-4.42l-1,4a17.18,17.18,0,0,0-4,1.26l-3.15-2.73-3.62,2.53,1.49,3.9a17.25,17.25,0,0,0-2.53,3.29l-4.16-.43-1.51,4.15,3.44,2.33a17.64,17.64,0,0,0-.24,2.93c0,.42,0,.83,0,1.24l-3.61,2,1.14,4.26,4.09-.05a18.06,18.06,0,0,0,2.25,3.57l-1.77,3.68,3.38,2.83L321.2,160m18.34-20.62a11,11,0,1,1-9.6-5.61,10.22,10.22,0,0,1,1.58.12m3.73,1.24a10.91,10.91,0,0,1,2.32,1.72",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.56,386.86l.66,3.95,4.4.39,1.32-3.74a17.42,17.42,0,0,0,4.23-.92l2.78,2.82,3.82-2.21-1-3.8a17.47,17.47,0,0,0,2.93-3.2l3.88.72,1.87-4-3-2.51a17.41,17.41,0,0,0,.55-4.3l3.62-1.64-.77-4.35-4-.31a16.87,16.87,0,0,0-2-3.78l2.06-3.48-3.12-3.12-3.5,2.08a17.63,17.63,0,0,0-6.69-2.73l-1-4h-4.42l-1,4a17.18,17.18,0,0,0-4,1.26L330,351.29l-3.62,2.53,1.49,3.9a17.25,17.25,0,0,0-2.53,3.29l-4.16-.43-1.51,4.15,3.44,2.33a17.64,17.64,0,0,0-.24,2.93c0,.42,0,.83,0,1.24l-3.61,2,1.14,4.26,4.09-.05a18.06,18.06,0,0,0,2.25,3.57L325,384.71l3.38,2.83,3.28-2.34M350,364.58a11,11,0,1,1-9.6-5.61,10.22,10.22,0,0,1,1.58.12m3.73,1.24a10.91,10.91,0,0,1,2.32,1.72",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,114.24l.58,1.52c-.29.29-.57.6-.84.91m-1.47,2c-.08.12-.15.24-.22.36l-4.16-.42-1.51,4.14,3.44,2.33a17.73,17.73,0,0,0-.25,2.93c0,.42,0,.83,0,1.24l-3.62,2,1.15,4.26,4.09,0a17.41,17.41,0,0,0,2.25,3.58l-1.77,3.67,3.38,2.84,3.28-2.35a17.61,17.61,0,0,0,3.94,1.67l.66,3.95,4.39.38,1.33-3.74a17.41,17.41,0,0,0,4.23-.91l2.77,2.81,3.82-2.2-1-3.8a17.8,17.8,0,0,0,2.93-3.2l3.88.71,1.87-4-3.05-2.52a17.82,17.82,0,0,0,.55-4.29l3.62-1.65-.77-4.34-4-.31a17.59,17.59,0,0,0-2-3.79l2.06-3.47-3.12-3.12-3.5,2.08a17.31,17.31,0,0,0-6.69-2.73l-1-4h-4.41l-1,4a17.68,17.68,0,0,0-4,1.26l-3.16-2.73-3.61,2.53.46,1.2m24.35,17.24a10.59,10.59,0,0,1-.67,2.11m-.83,1.55A11,11,0,1,1,381.1,128q0,.4,0,.81",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.23,250.29l-3.31,6.87,6.32,5.3,6.12-4.39a32.34,32.34,0,0,0,7.38,3.12l1.22,7.38,8.22.72,2.47-7a32.42,32.42,0,0,0,7.91-1.72l5.18,5.27,7.14-4.12-2-7.1a33.14,33.14,0,0,0,5.49-6l7.25,1.33,3.49-7.47-5.69-4.7a32.58,32.58,0,0,0,1-8l6.76-3.08-1.43-8.12-7.46-.58a33.14,33.14,0,0,0-3.73-7.07l3.84-6.5-5.83-5.83-6.55,3.89a32.38,32.38,0,0,0-12.5-5.1l-1.89-7.48h-8.25l-1.9,7.52a32.68,32.68,0,0,0-7.41,2.36l-5.9-5.1-6.75,4.73,2.78,7.29a32.83,32.83,0,0,0-4.73,6.14l-7.77-.8-2.82,7.75,6.43,4.36a33,33,0,0,0-.46,5.48q0,1.17.09,2.31l-6.77,3.78,2.14,8,7.65-.09a33.65,33.65,0,0,0,3,5.15m19.74-38.52a21.06,21.06,0,0,1,2.75-.76m5.08-.4a20.57,20.57,0,1,1-9.3,1.75",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bulb--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 198.88,
    y1: 228.09,
    x2: 190.7,
    y2: 222.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.09,
    y1: 212.21,
    x2: 210.97,
    y2: 210.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.21,
    y1: 258.77,
    x2: 172.28,
    y2: 254.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.71,362.83a1.5,1.5,0,0,1-.37-.05,1.53,1.53,0,0,1-.93-.7c-.52-.91-.8-1.4,3.42-6.24-9.1,5.57-10.07,5.34-10.6,5.21a1.77,1.77,0,0,1-1-.76c-.84-1.45-1-1.74,15.84-15.52-2.7,1.75-5.51,3.63-8,5.29-14.82,9.89-19.43,12.7-21.47,12.23a1.86,1.86,0,0,1-1.19-.87c-.9-1.56-.9-1.56,19-15.94l3.94-2.84c-2.3,1.53-4.59,3.09-6.69,4.52-15.66,10.65-22.79,15.25-25.46,14.65a2,2,0,0,1-1.32-1c-1-1.69-1.2-2.07,27.74-21.73l-38.06,22a1.48,1.48,0,0,1-2-.55c-.67-1.16-.15-2.58,2.6-5-4.38,2.52-6.92,3.53-8.17,3.24a2,2,0,0,1-1.26-.91c-.83-1.44-.51-2.77,10.08-9.89-10.92,6.83-14.95,8.84-16.52,8.47a1.76,1.76,0,0,1-1.12-.83c-.73-1.25-.05-1.7,2.46-3.36l5.53-3.61,8.46-5.47c-9.32,4.84-10.72,4.51-11.5,4.32a2,2,0,0,1-1.27-.92,1.5,1.5,0,0,1,.54-2c29.35-17.4,74.66-45.31,85.58-54.54-10.89,4.95-43.45,25.17-62,36.72-23.89,14.85-24,14.82-25,14.56a1.57,1.57,0,0,1-1-.72c-.81-1.4-.77-2.3,8.79-8.22-4.4,2.07-7.3,3-8.58,2.7a2.09,2.09,0,0,1-1.34-1,1.49,1.49,0,0,1,.49-2c29.62-18.87,71.29-45.59,88.29-56.88-4.73,2.41-11.08,6-18.14,10.23-5.71,3.67-12.48,7.94-20.49,12.92-10.58,6.59-21.28,13.12-30.19,18.52-21.52,13.58-21.78,13.52-22.83,13.26a1.61,1.61,0,0,1-1-.73,1.5,1.5,0,0,1,.54-2c6.48-3.85,13.63-8.14,21.05-12.64l3.9-2.46c-15.54,8.89-24.13,12.78-26.66,12.16a2.1,2.1,0,0,1-1.41-1c-.93-1.6.39-3.64,11.35-10.8-7.07,4.31-9.87,5.59-11.06,5.3a1.69,1.69,0,0,1-1.09-.8c-.63-1.09-1.14-2,6.18-7.31-3.94,2-6.43,2.81-7.62,2.52a2,2,0,0,1-1.3-.94,1.49,1.49,0,0,1-.15-1.15,1.52,1.52,0,0,1,.7-.91c32.45-18.45,81.59-47.67,96.55-59.46-16.41,9.06-61.65,35.62-93.22,54.34a1.5,1.5,0,0,1-2.06-.54,2.32,2.32,0,0,1-.19-1.82,9,9,0,0,1,2.46-3.28c-2.33.95-3.89,1.3-4.78,1.08a2.08,2.08,0,0,1-1.32-1c-.9-1.55.82-2.75,3.42-4.56,2-1.35,4.83-3.22,8.79-5.7,7.39-4.62,17.53-10.74,28.27-17.21,12.07-7.28,26.41-15.93,37.8-23.09-24.37,14-62.75,36.42-81.18,47.2a1.54,1.54,0,0,1-1.15.15,1.48,1.48,0,0,1-.91-.7c-.77-1.34-1-1.73,12.25-10.07-5.19,2.85-8.47,4.08-10.14,3.69a2.31,2.31,0,0,1-1.52-1.09c-1-1.72-1-1.72,23.06-15.69,11.13-6.46,24.41-14.18,36.63-21.6,10.26-6.82,18.29-12,24.38-15.6a77.26,77.26,0,0,0,9.07-7.06c-12.49,5.61-61.81,35.43-93,54.83a1.5,1.5,0,0,1-1.6-2.54l9.68-6.16c-8,4.11-11,4.8-12.23,4.49a2.06,2.06,0,0,1-1.33-1,1.48,1.48,0,0,1,.49-2l21.31-13.66c-17.42,9.84-18.83,9.49-19.69,9.27a1.73,1.73,0,0,1-1.1-.81,1.5,1.5,0,0,1,.51-2c22.46-13.89,54.37-34,73-46.61-15.05,8.67-37,21.55-52.44,30.63L203,261.79c-3.82,2.23-5.67,3.32-6.66,3.82l-.26.16,0,0c-.69.33-.86.28-1.15.2a1.5,1.5,0,0,1-.41-2.72c23.82-14.73,59-36.93,74.76-47.85-8.39,4.86-20.92,12.85-31,19.3-28.26,18-36.85,23.18-39.34,22.56a1.81,1.81,0,0,1-1.14-.84c-.62-1.09-1.07-1.86,8.32-8.63-2.56,1.13-4.29,1.56-5.3,1.32a2.17,2.17,0,0,1-1.38-1,1.51,1.51,0,0,1,.5-2c18.45-11.61,46.49-29.81,56.13-37.34-8.44,4.13-26.86,16-37.7,22.94C200.66,243,200,243.28,198.87,243a1.58,1.58,0,0,1-1-.73c-.8-1.37-1.5-2.59,15.84-14.51-2.14,1.36-4.33,2.77-6.57,4.21a1.57,1.57,0,0,1-1.34.31,1.47,1.47,0,0,1-.94-.71c-1.07-1.85.47-3.44,12.64-12.77a1.62,1.62,0,0,1-1.07-.78A1.51,1.51,0,0,1,217,216a1.6,1.6,0,0,1,.92-.19,51.88,51.88,0,0,0,4.59-3c4.88-3.43,6.26-4.25,7.45-4a1.73,1.73,0,0,1,1.12.81c.86,1.5.19,2.4-8,8.74,2.28-1.41,4.63-2.87,7-4.31,23.12-14.14,24.91-13.72,26-13.46a1.75,1.75,0,0,1,1.15.84,1.5,1.5,0,0,1-.5,2c-11.28,7-23,14.58-32.83,21.13,22.82-14.57,33.79-21,36.88-20.22a2,2,0,0,1,1.29.94c.95,1.65,1.64,2.85-29.93,23.63l-4.54,3c6.36-4,12.8-8.2,18-11.6,20.25-13.14,23.53-15.07,25.06-14.71a1.62,1.62,0,0,1,1,.77,1.49,1.49,0,0,1-.49,2c-19.58,12.48-48.18,31.11-62.32,41.12,7.6-4.48,18.37-11.35,27.75-17.33,29.73-19,39.43-24.75,42.17-24.09a1.88,1.88,0,0,1,1.18.87c.73,1.27,1.26,2.17-16.13,13.78,24.37-14.14,24.84-14,25.61-13.82a1.53,1.53,0,0,1,.94.71c1,1.73,1.71,3-44.27,32.38-3.34,2.14-6.69,4.27-10,6.35,18.2-10.76,39.89-24,56.32-34.26a1.53,1.53,0,0,1,1.16-.18,1.54,1.54,0,0,1,.94.7c.71,1.24-.34,2-1.45,2.76-.68.47-1.68,1.15-3,2-2.42,1.61-6,4-10.62,7-7.78,5.07-18.65,12.1-32.31,20.9-13.16,8.47-26.42,17-35.51,22.81C223.64,263.72,247,250,292,221.25c6.48-4.13,6.48-4.13,7.14-4a1.52,1.52,0,0,1,.95.71c.37.64.58,1-.62,2.07h0l0,0c-1.6,1.4-5.58,4-14.66,9.9,12.86-7.05,14.06-6.76,14.84-6.56a1.69,1.69,0,0,1,1.09.8c.54.94.67,2.07-1.33,4.31a5.39,5.39,0,0,1,2.44-.18,2.38,2.38,0,0,1,1.57,1.13c1,1.72,1.5,2.6-28.21,21.34,31.46-18.22,31.77-18.14,32.52-17.94a1.48,1.48,0,0,1,.92.7c1,1.66-.8,3.33-5.1,6.47-2.77,2-6.68,4.64-11.92,8,17.47-10.91,21.85-13.17,23.41-12.79a1.69,1.69,0,0,1,1.06.79,1.47,1.47,0,0,1,.15,1.14,1.49,1.49,0,0,1-.71.92c-10.2,5.78-20.57,11.76-30.59,17.66l-10.38,6.56c-20.41,12.92-35.3,22.21-45.75,28.29-3.31,2.27-6.14,4.29-8.41,6,9.3-5.5,25.14-14.85,41-24.1,50-29.26,50.76-29.05,51.71-28.8a1.53,1.53,0,0,1,.94.71,2.18,2.18,0,0,1,.19,1.7,5.31,5.31,0,0,1-1.63,2.49c3.43-1.71,5.58-2.41,6.64-2.16a1.94,1.94,0,0,1,1.24.91c.8,1.38-.32,2.13-2.79,3.77-1.49,1-3.69,2.39-6.74,4.29l-.59.37c4.66-2.23,7.93-3.28,9.57-2.88a2.47,2.47,0,0,1,1.62,1.15c1.38,2.39,0,3.91-48.79,32.77C252.29,299,225.22,315,217.84,321c4.07-1.43,14.21-6.33,39.41-21.58,20.54-12.43,43.16-26.94,54-33.91,7.53-4.83,7.52-4.82,8.19-4.66a1.55,1.55,0,0,1,.95.71c.61,1.06,1.23,2.13-7,8.26a7.5,7.5,0,0,1,3.71-.64,2.1,2.1,0,0,1,1.34,1c.88,1.53.88,1.53-15.3,12.13-8,5.22-19.1,12.43-33.1,21.43-13.5,8.68-27.11,17.39-36.43,23.34,18.88-10.12,54.26-32.56,70-42.54,14-8.85,14-8.85,14.76-8.66a1.53,1.53,0,0,1,.94.71c1.07,1.86-.63,4.5-7.21,9.39a2.06,2.06,0,0,1,.58,0,1.88,1.88,0,0,1,1.18.87c1.05,1.82,2.24,3.88-42.14,31.67,12.76-7.86,26-16.22,36.69-23.15a1.5,1.5,0,0,1,2.12.51c.73,1.28-.28,2-2,3.2-1,.71-2.51,1.75-4.49,3.07s-4.44,3-7.41,4.92c4.14-2.1,6.7-2.95,8-2.63a2.08,2.08,0,0,1,1.35,1c.84,1.45.65,2-9.47,8.54,2.13-.91,3.64-1.24,4.61-1a2.22,2.22,0,0,1,1.45,1.05c1.18,2,.29,2.94-26.81,19.35-7.76,4.7-17.53,10.61-25.44,15.71l53.21-30.71a1.46,1.46,0,0,1,1.14-.15,1.51,1.51,0,0,1,.91.69c.74,1.29-.31,2.06-2.05,3.34-1.05.77-2.59,1.86-4.71,3.32-3.95,2.74-9.44,6.45-15.25,10.39-6.77,4.58-15.29,10.35-22.27,15.2,3.21-2.12,6.55-4.39,9.52-6.41,15.47-10.52,22-14.73,24.55-14.17a2,2,0,0,1,1.29.93c.87,1.52.91,1.59-16.83,14.44,12.87-8.56,17.08-11,19-10.57a1.86,1.86,0,0,1,1.19.87c.7,1.22.7,1.22-8.25,8.53-2.7,2.2-6.45,5.26-9.83,8.09,2.74-1.69,5.76-3.61,8.63-5.47a1.5,1.5,0,0,1,2.12.51c.56,1,.35,1.2-1.7,3.4-1.67,1.79-3.1,3.36-4.31,4.7,9.08-5.41,9.41-5.32,10.05-5.16a1.51,1.51,0,0,1,.93.71,1.49,1.49,0,0,1-.55,2.05,1.43,1.43,0,0,1-.47.18c-1.33.6-8.72,4.95-15.23,8.89A1.56,1.56,0,0,1,280.71,362.83ZM295.14,353a1.52,1.52,0,0,0,.68.61A1.59,1.59,0,0,1,295.14,353Zm-36.92-15.27c-8.64,5.39-17.14,10.79-22.68,14.64C241.57,348.78,250.33,343,258.22,337.73Zm37.19-26.63c-9.81,5.44-25.68,15.66-37.74,23.45,4.44-2.77,9.5-5.9,15.25-9.44C280.84,320.24,289.37,315,295.41,311.1Zm-.64,7c-5.33,2.84-13.42,8-21.31,13.15l.83-.5C281.66,326.27,289.66,321.42,294.77,318.08ZM245.6,295.64C239,299.77,233,303.66,228,307,233.18,303.69,239.32,299.72,245.6,295.64Zm71.19-39.33c-2.9,1-9.05,3.8-22.06,11.61S266,286,252,295.1c-6.11,4-11.25,7.3-15.59,10.08,8.42-5.18,19.73-11.95,34.84-20.89C289.64,273.38,310.2,261.22,316.79,256.31Zm-9.39,29.34L305.28,287q-10.5,6.67-19.89,12.55C293.74,294.53,301.63,289.62,307.4,285.65ZM241.08,279c-9.17,5.54-18.08,11-24,14.73,3-1.53,6.61-3.58,10.69-6C231.78,285,236.27,282.05,241.08,279Zm23.48-26.42c-3.84,2.56-7.62,5.1-11.16,7.47-7,4.72-13.22,8.84-18.61,12.38l5.51-3.4c20.25-12.48,49.49-30.52,58.09-37.06a79.11,79.11,0,0,0-9.23,4.88c-3.42,2.39-7.77,5.26-13.28,8.74C272.29,247.84,268.48,250.18,264.56,252.56Zm-45.51-36Z",
    style: {
      fill: "#AE460C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.71,362.83a1.5,1.5,0,0,1-.37-.05,1.53,1.53,0,0,1-.93-.7c-.52-.91-.8-1.4,3.42-6.24-9.1,5.57-10.07,5.34-10.6,5.21a1.77,1.77,0,0,1-1-.76c-.84-1.45-1-1.74,15.84-15.52-2.7,1.75-5.51,3.63-8,5.29-14.82,9.89-19.43,12.7-21.47,12.23a1.86,1.86,0,0,1-1.19-.87c-.9-1.56-.9-1.56,19-15.94l3.94-2.84c-2.3,1.53-4.59,3.09-6.69,4.52-15.66,10.65-22.79,15.25-25.46,14.65a2,2,0,0,1-1.32-1c-1-1.69-1.2-2.07,27.74-21.73l-38.06,22a1.48,1.48,0,0,1-2-.55c-.67-1.16-.15-2.58,2.6-5-4.38,2.52-6.92,3.53-8.17,3.24a2,2,0,0,1-1.26-.91c-.83-1.44-.51-2.77,10.08-9.89-10.92,6.83-14.95,8.84-16.52,8.47a1.76,1.76,0,0,1-1.12-.83c-.73-1.25-.05-1.7,2.46-3.36l5.53-3.61,8.46-5.47c-9.32,4.84-10.72,4.51-11.5,4.32a2,2,0,0,1-1.27-.92,1.5,1.5,0,0,1,.54-2c29.35-17.4,74.66-45.31,85.58-54.54-10.89,4.95-43.45,25.17-62,36.72-23.89,14.85-24,14.82-25,14.56a1.57,1.57,0,0,1-1-.72c-.81-1.4-.77-2.3,8.79-8.22-4.4,2.07-7.3,3-8.58,2.7a2.09,2.09,0,0,1-1.34-1,1.49,1.49,0,0,1,.49-2c29.62-18.87,71.29-45.59,88.29-56.88-4.73,2.41-11.08,6-18.14,10.23-5.71,3.67-12.48,7.94-20.49,12.92-10.58,6.59-21.28,13.12-30.19,18.52-21.52,13.58-21.78,13.52-22.83,13.26a1.61,1.61,0,0,1-1-.73,1.5,1.5,0,0,1,.54-2c6.48-3.85,13.63-8.14,21.05-12.64l3.9-2.46c-15.54,8.89-24.13,12.78-26.66,12.16a2.1,2.1,0,0,1-1.41-1c-.93-1.6.39-3.64,11.35-10.8-7.07,4.31-9.87,5.59-11.06,5.3a1.69,1.69,0,0,1-1.09-.8c-.63-1.09-1.14-2,6.18-7.31-3.94,2-6.43,2.81-7.62,2.52a2,2,0,0,1-1.3-.94,1.49,1.49,0,0,1-.15-1.15,1.52,1.52,0,0,1,.7-.91c32.45-18.45,81.59-47.67,96.55-59.46-16.41,9.06-61.65,35.62-93.22,54.34a1.5,1.5,0,0,1-2.06-.54,2.32,2.32,0,0,1-.19-1.82,9,9,0,0,1,2.46-3.28c-2.33.95-3.89,1.3-4.78,1.08a2.08,2.08,0,0,1-1.32-1c-.9-1.55.82-2.75,3.42-4.56,2-1.35,4.83-3.22,8.79-5.7,7.39-4.62,17.53-10.74,28.27-17.21,12.07-7.28,26.41-15.93,37.8-23.09-24.37,14-62.75,36.42-81.18,47.2a1.54,1.54,0,0,1-1.15.15,1.48,1.48,0,0,1-.91-.7c-.77-1.34-1-1.73,12.25-10.07-5.19,2.85-8.47,4.08-10.14,3.69a2.31,2.31,0,0,1-1.52-1.09c-1-1.72-1-1.72,23.06-15.69,11.13-6.46,24.41-14.18,36.63-21.6,10.26-6.82,18.29-12,24.38-15.6a77.26,77.26,0,0,0,9.07-7.06c-12.49,5.61-61.81,35.43-93,54.83a1.5,1.5,0,0,1-1.6-2.54l9.68-6.16c-8,4.11-11,4.8-12.23,4.49a2.06,2.06,0,0,1-1.33-1,1.48,1.48,0,0,1,.49-2l21.31-13.66c-17.42,9.84-18.83,9.49-19.69,9.27a1.73,1.73,0,0,1-1.1-.81,1.5,1.5,0,0,1,.51-2c22.46-13.89,54.37-34,73-46.61-15.05,8.67-37,21.55-52.44,30.63L203,261.79c-3.82,2.23-5.67,3.32-6.66,3.82l-.26.16,0,0c-.69.33-.86.28-1.15.2a1.5,1.5,0,0,1-.41-2.72c23.82-14.73,59-36.93,74.76-47.85-8.39,4.86-20.92,12.85-31,19.3-28.26,18-36.85,23.18-39.34,22.56a1.81,1.81,0,0,1-1.14-.84c-.62-1.09-1.07-1.86,8.32-8.63-2.56,1.13-4.29,1.56-5.3,1.32a2.17,2.17,0,0,1-1.38-1,1.51,1.51,0,0,1,.5-2c18.45-11.61,46.49-29.81,56.13-37.34-8.44,4.13-26.86,16-37.7,22.94C200.66,243,200,243.28,198.87,243a1.58,1.58,0,0,1-1-.73c-.8-1.37-1.5-2.59,15.84-14.51-2.14,1.36-4.33,2.77-6.57,4.21a1.57,1.57,0,0,1-1.34.31,1.47,1.47,0,0,1-.94-.71c-1.07-1.85.47-3.44,12.64-12.77a1.62,1.62,0,0,1-1.07-.78A1.51,1.51,0,0,1,217,216a1.6,1.6,0,0,1,.92-.19,51.88,51.88,0,0,0,4.59-3c4.88-3.43,6.26-4.25,7.45-4a1.73,1.73,0,0,1,1.12.81c.86,1.5.19,2.4-8,8.74,2.28-1.41,4.63-2.87,7-4.31,23.12-14.14,24.91-13.72,26-13.46a1.75,1.75,0,0,1,1.15.84,1.5,1.5,0,0,1-.5,2c-11.28,7-23,14.58-32.83,21.13,22.82-14.57,33.79-21,36.88-20.22a2,2,0,0,1,1.29.94c.95,1.65,1.64,2.85-29.93,23.63l-4.54,3c6.36-4,12.8-8.2,18-11.6,20.25-13.14,23.53-15.07,25.06-14.71a1.62,1.62,0,0,1,1,.77,1.49,1.49,0,0,1-.49,2c-19.58,12.48-48.18,31.11-62.32,41.12,7.6-4.48,18.37-11.35,27.75-17.33,29.73-19,39.43-24.75,42.17-24.09a1.88,1.88,0,0,1,1.18.87c.73,1.27,1.26,2.17-16.13,13.78,24.37-14.14,24.84-14,25.61-13.82a1.53,1.53,0,0,1,.94.71c1,1.73,1.71,3-44.27,32.38-3.34,2.14-6.69,4.27-10,6.35,18.2-10.76,39.89-24,56.32-34.26a1.53,1.53,0,0,1,1.16-.18,1.54,1.54,0,0,1,.94.7c.71,1.24-.34,2-1.45,2.76-.68.47-1.68,1.15-3,2-2.42,1.61-6,4-10.62,7-7.78,5.07-18.65,12.1-32.31,20.9-13.16,8.47-26.42,17-35.51,22.81C223.64,263.72,247,250,292,221.25c6.48-4.13,6.48-4.13,7.14-4a1.52,1.52,0,0,1,.95.71c.37.64.58,1-.62,2.07h0l0,0c-1.6,1.4-5.58,4-14.66,9.9,12.86-7.05,14.06-6.76,14.84-6.56a1.69,1.69,0,0,1,1.09.8c.54.94.67,2.07-1.33,4.31a5.39,5.39,0,0,1,2.44-.18,2.38,2.38,0,0,1,1.57,1.13c1,1.72,1.5,2.6-28.21,21.34,31.46-18.22,31.77-18.14,32.52-17.94a1.48,1.48,0,0,1,.92.7c1,1.66-.8,3.33-5.1,6.47-2.77,2-6.68,4.64-11.92,8,17.47-10.91,21.85-13.17,23.41-12.79a1.69,1.69,0,0,1,1.06.79,1.47,1.47,0,0,1,.15,1.14,1.49,1.49,0,0,1-.71.92c-10.2,5.78-20.57,11.76-30.59,17.66l-10.38,6.56c-20.41,12.92-35.3,22.21-45.75,28.29-3.31,2.27-6.14,4.29-8.41,6,9.3-5.5,25.14-14.85,41-24.1,50-29.26,50.76-29.05,51.71-28.8a1.53,1.53,0,0,1,.94.71,2.18,2.18,0,0,1,.19,1.7,5.31,5.31,0,0,1-1.63,2.49c3.43-1.71,5.58-2.41,6.64-2.16a1.94,1.94,0,0,1,1.24.91c.8,1.38-.32,2.13-2.79,3.77-1.49,1-3.69,2.39-6.74,4.29l-.59.37c4.66-2.23,7.93-3.28,9.57-2.88a2.47,2.47,0,0,1,1.62,1.15c1.38,2.39,0,3.91-48.79,32.77C252.29,299,225.22,315,217.84,321c4.07-1.43,14.21-6.33,39.41-21.58,20.54-12.43,43.16-26.94,54-33.91,7.53-4.83,7.52-4.82,8.19-4.66a1.55,1.55,0,0,1,.95.71c.61,1.06,1.23,2.13-7,8.26a7.5,7.5,0,0,1,3.71-.64,2.1,2.1,0,0,1,1.34,1c.88,1.53.88,1.53-15.3,12.13-8,5.22-19.1,12.43-33.1,21.43-13.5,8.68-27.11,17.39-36.43,23.34,18.88-10.12,54.26-32.56,70-42.54,14-8.85,14-8.85,14.76-8.66a1.53,1.53,0,0,1,.94.71c1.07,1.86-.63,4.5-7.21,9.39a2.06,2.06,0,0,1,.58,0,1.88,1.88,0,0,1,1.18.87c1.05,1.82,2.24,3.88-42.14,31.67,12.76-7.86,26-16.22,36.69-23.15a1.5,1.5,0,0,1,2.12.51c.73,1.28-.28,2-2,3.2-1,.71-2.51,1.75-4.49,3.07s-4.44,3-7.41,4.92c4.14-2.1,6.7-2.95,8-2.63a2.08,2.08,0,0,1,1.35,1c.84,1.45.65,2-9.47,8.54,2.13-.91,3.64-1.24,4.61-1a2.22,2.22,0,0,1,1.45,1.05c1.18,2,.29,2.94-26.81,19.35-7.76,4.7-17.53,10.61-25.44,15.71l53.21-30.71a1.46,1.46,0,0,1,1.14-.15,1.51,1.51,0,0,1,.91.69c.74,1.29-.31,2.06-2.05,3.34-1.05.77-2.59,1.86-4.71,3.32-3.95,2.74-9.44,6.45-15.25,10.39-6.77,4.58-15.29,10.35-22.27,15.2,3.21-2.12,6.55-4.39,9.52-6.41,15.47-10.52,22-14.73,24.55-14.17a2,2,0,0,1,1.29.93c.87,1.52.91,1.59-16.83,14.44,12.87-8.56,17.08-11,19-10.57a1.86,1.86,0,0,1,1.19.87c.7,1.22.7,1.22-8.25,8.53-2.7,2.2-6.45,5.26-9.83,8.09,2.74-1.69,5.76-3.61,8.63-5.47a1.5,1.5,0,0,1,2.12.51c.56,1,.35,1.2-1.7,3.4-1.67,1.79-3.1,3.36-4.31,4.7,9.08-5.41,9.41-5.32,10.05-5.16a1.51,1.51,0,0,1,.93.71,1.49,1.49,0,0,1-.55,2.05,1.43,1.43,0,0,1-.47.18c-1.33.6-8.72,4.95-15.23,8.89A1.56,1.56,0,0,1,280.71,362.83ZM295.14,353a1.52,1.52,0,0,0,.68.61A1.59,1.59,0,0,1,295.14,353Zm-36.92-15.27c-8.64,5.39-17.14,10.79-22.68,14.64C241.57,348.78,250.33,343,258.22,337.73Zm37.19-26.63c-9.81,5.44-25.68,15.66-37.74,23.45,4.44-2.77,9.5-5.9,15.25-9.44C280.84,320.24,289.37,315,295.41,311.1Zm-.64,7c-5.33,2.84-13.42,8-21.31,13.15l.83-.5C281.66,326.27,289.66,321.42,294.77,318.08ZM245.6,295.64C239,299.77,233,303.66,228,307,233.18,303.69,239.32,299.72,245.6,295.64Zm71.19-39.33c-2.9,1-9.05,3.8-22.06,11.61S266,286,252,295.1c-6.11,4-11.25,7.3-15.59,10.08,8.42-5.18,19.73-11.95,34.84-20.89C289.64,273.38,310.2,261.22,316.79,256.31Zm-9.39,29.34L305.28,287q-10.5,6.67-19.89,12.55C293.74,294.53,301.63,289.62,307.4,285.65ZM241.08,279c-9.17,5.54-18.08,11-24,14.73,3-1.53,6.61-3.58,10.69-6C231.78,285,236.27,282.05,241.08,279Zm23.48-26.42c-3.84,2.56-7.62,5.1-11.16,7.47-7,4.72-13.22,8.84-18.61,12.38l5.51-3.4c20.25-12.48,49.49-30.52,58.09-37.06a79.11,79.11,0,0,0-9.23,4.88c-3.42,2.39-7.77,5.26-13.28,8.74C272.29,247.84,268.48,250.18,264.56,252.56Zm-45.51-36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.47,202.55v0h-.67v0c-36.26.67-63.59,28.41-63.59,62.54a62.27,62.27,0,0,0,7.24,29.24c2,4.75,6.84,16.38,11.63,31.42,4.44,13.88,6.76,27.85,6.76,30,0,.2,0,.41,0,.64a4.69,4.69,0,0,0,4.68,4.84h64.94a4.69,4.69,0,0,0,4.68-4.84c0-.23,0-.44,0-.64,0-2.11,2.32-16.08,6.75-30,4.8-15,9.59-26.67,11.63-31.42a62.56,62.56,0,0,0-54-91.78Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.38,212.59a51.44,51.44,0,0,0-5.56-2.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.22,228.47s-5.1-8.1-16.31-13.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.84,332.87V300.75s2.47-15.64-5.66-15.64-7.51,8.14,1.87,16.89,23.78.63,25.66-6.25-3.13-10-6.26-4.38,0,69.45,0,69.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.45,
    y1: 186.3,
    x2: 239.91,
    y2: 197.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.23,
    y1: 210.05,
    x2: 309.84,
    y2: 218.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279,
    y1: 178.35,
    x2: 274.71,
    y2: 197.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.09,
    y: 365.91,
    width: 71.77,
    height: 3.97,
    rx: 1.59,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.09,
    y: 374.85,
    width: 71.77,
    height: 3.97,
    rx: 1.59,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.09,
    y: 383.79,
    width: 71.77,
    height: 3.97,
    rx: 1.59,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.08,392.52H224.86l10.14,14a9.37,9.37,0,0,0,7.6,3.88h31a9.39,9.39,0,0,0,7.61-3.9l10.06-13.93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.69,243s-6.4,7-11.64,10.48-8.89,8.11-4.08,10.48c2.89,1.42,7-.58,7-.58s-6.41,1.74-7.57,7.57S331,274.42,331,274.42s-9.31,6.4-6.4,8.73,8.73.58,11.64.58,17.47-9.31,21-9.31,10.48,7.57,10.48,13.39S377,293.05,378.19,275s-3.49-33.18-11.06-37.84S335.69,243,335.69,243Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.2,262.77l23.23-8.68s10.2-2.21,17.52,9.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.27,269.76l21-3.49s9.32-.58,15.14,10.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.89,283.73l-15.72,3.5,9.31,37.25s8.16,16.3,10.48,23.29S392.16,378,392.16,378l27.94-26.78s-12.8-15.13-13.38-18.63-2.92-44.24-2.92-50.06-11.64-19.8-11.64-19.8-4.78-6.85-7.11-18.49-13-16.43-18.84-15.85-21.79,2.33-28.19,7-12.23,10.48-6.4,12.23c9.67,2.9,25.49-10,33.12-1.08,3.5,4.07,7.63,22,8.21,24.37,0,0-2.91,11.06-11.06,12.8h0",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.27,229.62a1.08,1.08,0,0,1,1.4-.14l2.38,1.65a1.09,1.09,0,0,1,.27,1.51,1.08,1.08,0,0,1-1.5.27l-2.38-1.66a1.08,1.08,0,0,1-.27-1.5A.64.64,0,0,1,303.27,229.62Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,231.54a2.45,2.45,0,0,1,3.2-.33l7.46,3.84,73.24,48.18a5.79,5.79,0,0,1-6.61,9.51L312.21,240.3l-5.81-5a2.47,2.47,0,0,1-.62-3.44A2,2,0,0,1,306,231.54Z",
    style: {
      fill: "#AE460C",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.91,283.23l-21.14-13.9a8,8,0,0,0-5.77,7.48,6.66,6.66,0,0,0,.08,1l20.22,14.92a5.79,5.79,0,0,0,6.61-9.51Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,347.77c-6.4-9.31-14.55-33.18-18-37.84s-12.86-15-16.35-25.44-5.78-18.8-5.78-27.54,7.51-10.24,13.33-.92S352,279.66,352,279.66s4.66,5.82,14,4.07",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.09,253.31l2,3.89s-.44,0-3.55,1.77a12.67,12.67,0,0,0-4.53,4.39s-3-8.38-.35-11a4.22,4.22,0,0,1,2.42-1.27A4,4,0,0,1,333.09,253.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,339.36s-15.41,4.56-23.41,12.56a183.76,183.76,0,0,0-14.85,17.13l14.28,16.56s12-13.71,20-20a154,154,0,0,1,17.13-11.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.31,459.84,383.2,387.32s11.42-17.13,21.13-25.69,22.27-10.85,22.27-10.85L483,404.91",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.4,274.49l1-.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.69,279.33s.53-3.19,6.94-4.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.65,277.08s-.45,1.35-4.94,3.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.47,272.81a14.8,14.8,0,0,0-6.24,2.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.76,173.35s9.44.77,15.42,2.76,11.86,2,10.77-3.22c-.65-3.15-4.75-5.16-4.75-5.16s5.31,4,10.62,1.33-4.39-11.33-4.39-11.33,10.78,3.42,10.83-.31-4.9-7.25-6.69-9.55-18.07-8.07-20.22-10.82-.46-12.92,4.14-16.5S212.91,110,198,120.14s-24,23.13-23.09,32S198.76,173.35,198.76,173.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.53,164l-21.12-13s-8-6.69-3-19.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.54,156.45l-15.62-14.4s-6.18-7-1-18.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.85,127.65l12.4,10.27L251,107.69s15.3-6.87,19.33-13,7.46-39.33,7.46-39.33L239.4,50s-3.91,19.44-6.29,22.07S192.79,91.7,188.2,95.28s-8.48,21.34-8.48,21.34a128.19,128.19,0,0,1-8,21c-8.75,17.72-7.19,16.36-3.16,20.6s13.84,12.86,21.45,15.06,17.07,10.06,14.95.45c-2.18-9.85-23.54-14-21.19-25.48,1.07-5.26,12.72-19.55,14.2-21.44,0,0,10.51-4.49,16.9.87h0",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.12,207.15a1.08,1.08,0,0,1-1-1l-.15-2.9a1.08,1.08,0,1,1,2.15-.12l.16,2.9a1.08,1.08,0,0,1-1,1.14Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,203.8a2.45,2.45,0,0,1-2.23-2.32l-1.54-8.25-6.93-87.39a5.79,5.79,0,0,1,11.57-.62l2.24,88.31-.42,7.69a2.46,2.46,0,0,1-2.33,2.59A2.17,2.17,0,0,1,208,203.8Z",
    style: {
      fill: "#AE460C",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.25,105.84l2,25.22a8,8,0,0,0,9.45,0,7,7,0,0,0,.75-.68l-.63-25.12a5.79,5.79,0,0,0-11.57.62Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.28,94.65C267,105.46,252.52,120.32,250,125.56a261.37,261.37,0,0,1-19.56,34.19c-2.49,3.73-5.18,4.26-6.82,5.6-2.4,2-3.63,4.05-7.73,7.23-6.89,5.36-12.69.37-8.91-9.94S217.7,138,217.7,138s1.74-7.25-5.35-13.53",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.5,169.06l1.88-3.92s.27.35,3.58,1.71a12.65,12.65,0,0,0,6.24.88s-4.77,7.52-8.5,7.05a4.17,4.17,0,0,1-2.48-1.13A4,4,0,0,1,208.5,169.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.16,18.67,228.21,70.3S237.8,78.73,250.54,81s36,5.71,36,5.71l20.36-68.06",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.44,75.17a3.93,3.93,0,1,1-3.93-3.93A3.93,3.93,0,0,1,282.44,75.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.21,156.31l-.67-.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.37,160.22s-2.84,1.54-7.83-2.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.32,156.1s1.34-.47,5.52,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07,158.88a14.83,14.83,0,0,0,5.82,3.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.94,327.17s.91,9.43,3,15.38,2.21,11.83-3.06,10.82c-3.16-.61-5.23-4.67-5.23-4.67s4.07,5.25,1.49,10.59-11.4-4.22-11.4-4.22,3.58,10.72-.14,10.83-7.33-4.79-9.65-6.54-8.34-18-11.13-20.06-12.92-.27-16.42,4.38-10.6-1.42-.66-16.53,22.77-24.4,31.61-23.56S219.94,327.17,219.94,327.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.81,345.08l-13.32-20.93s-6.81-7.91-19.92-2.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.35,348.2l-14.63-15.41s-7.09-6.07-18.39-.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.49,343.93l10.44,12.26-29.87,24.14s-16.32,8.1-22.38,12.28S93.53,401,93.53,401L87.35,362.8s19.34-4.37,21.9-6.81,29-33.57,32.47-38.22,21.22-8.8,21.22-8.8,7.94-2.59,16.81-10.48,20.28-5.28,24.58-1.31,16,15,18.31,22.54,3.45,15.73-2.25,13.62c-9.47-3.51-14.34-23.32-25.8-20.81-5.24,1.15-19.36,13-21.22,14.52,0,0-4.34,10.58,1.12,16.88h0",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.87,336a1.08,1.08,0,0,0-1-1l-2.9-.11a1.08,1.08,0,1,0-.08,2.16l2.9.11a1.09,1.09,0,0,0,1.12-1A.76.76,0,0,0,253.87,336Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.53,335.91a2.47,2.47,0,0,0-2.36-2.2l-8.27-1.42-87.48-5.63a5.79,5.79,0,0,0-.45,11.58l88.33.92,7.68-.52a2.47,2.47,0,0,0,2.56-2.37A2.17,2.17,0,0,0,250.53,335.91Z",
    style: {
      fill: "#AE460C",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.42,326.66l25.24,1.63a8,8,0,0,1,.11,9.45,9.83,9.83,0,0,1-.67.76L152,338.24a5.79,5.79,0,0,1,.45-11.58Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.68,392.61c10.72-3.58,31.6-17.73,37.19-19.35s19.27-4.2,28.37-10.46,15.93-11.54,21.19-18.52.18-12.69-10.08-8.76-24.51,11.12-24.51,11.12-7.22,1.84-13.61-5.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.8,337l-3.9,1.93s.36.27,1.77,3.55a12.67,12.67,0,0,1,1,6.24s7.45-4.88,6.92-8.61a4.22,4.22,0,0,0-1.16-2.47A4,4,0,0,0,215.8,337Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.18,354.57s9.56,12.93,11.13,24.13a183.06,183.06,0,0,1,1.54,22.61l-29.19,7s-1.32-18.16-3.92-28a154,154,0,0,0-6.8-19.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.51,377.13c-2.6-12.68-11.25-22.07-11.25-22.07l-69.07,11v78l81.72-33.71S111.1,389.81,108.51,377.13Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,411A3.06,3.06,0,1,1,87,408,3.06,3.06,0,0,1,90,411Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.58,407.36a3.06,3.06,0,1,1-3.06-3.07A3.06,3.06,0,0,1,98.58,407.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.4,348.89l-.68-.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.45,358s1.5-2.87-2.81-7.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.25,352s-.46,1.35,2.05,5.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,348.71a14.76,14.76,0,0,1,3.45,5.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card-1.184cc4f21a469cbb5c06955720a5481e.svg";
export { ForwardRef as ReactComponent };